import { CE_PERIOD_CLOSE } from '../../../api/endpoints';
import request from '../../../api/request';
import { GetSectionsTeacherPortalByIDReponse } from '../../../api/requests/MantainerPortal';

export const getSectionsTeacherPortalByIDRequest = (sectionID: string) => {
  const url = CE_PERIOD_CLOSE.GET_SECTION_BY_ID(sectionID);
  return request<GetSectionsTeacherPortalByIDReponse>(url, {
    method: 'get',
  });
};

export const importOnlineAssistance = (sectionID: string) => {
  const url = CE_PERIOD_CLOSE.IMPORT_ONLINE_ASSISTANCE(sectionID);
  return request<any>(url, {
    method: 'post',
  });
};

export const postClosedSectionTeacherPortalRequest = (sectionId: number) => {
  const url = CE_PERIOD_CLOSE.POST_CLOSED_SECTION(sectionId);
  return request<any>(url, {
    method: 'post',
  });
};

export const postRejectClosureSectionMantainerPortalRequest = (
  sectionId: number,
) => {
  const url = CE_PERIOD_CLOSE.POST_REJECT_CLOSURE_SECTION(sectionId);
  return request<any>(url, {
    method: 'post',
  });
};

export const getPDFOfSectionClose = (sectionId: number) => {
  const url = CE_PERIOD_CLOSE.DOWNLOAD_PDF_SECTION_CLOSE(sectionId);
  return request<any>(url, {
    method: 'get',
    responseType: 'blob',
  });
};
